import { useContext } from "react";
import GuestbookContext from "../context/GuestbookContext";
import { useMutation } from "@tanstack/react-query";
import { likeComment, unlikeComment } from "../requests";
import { useComments } from "./useComments";

export const useCommentMutations = commentId => {
  const {guestbookKey} = useContext(GuestbookContext)
  const {mutateComment, invalidate} = useComments()

  const likeCommentMutation = useMutation({
    mutationFn: () => likeComment({commentId, guestbookKey}),
    onMutate: () => mutateComment(commentId, (comment) => ({
      ...comment,
      isLiked: true,
      likesCount: comment.likesCount + 1,
    })),
    onError: invalidate,
  })

  const unlikeCommentMutation = useMutation({
    mutationFn: () => unlikeComment({commentId, guestbookKey}),
    onMutate: () => mutateComment(commentId, (comment) => ({
      ...comment,
      isLiked: false,
      likesCount: comment.likesCount - 1,
    })),
    onError: invalidate,
  })

  return {
    likeComment: likeCommentMutation.mutate,
    unlikeComment: unlikeCommentMutation.mutate,
  }
}